import AppConfig, { ACTIVITY_LOGS_PATH, AppRoutes } from '../AppConfig.ts';
import { UserProfile } from '../types';

const REQUESTED_PATH_KEY = 'requested_path';

const CALLBACK_PATHS: string[] = [
  `/${AppRoutes.OIDC_CALLBACK}`,
  `/${AppRoutes.LOGOUT_CALLBACK}`,
  `/${AppRoutes.LOGIN_CALLBACK}`,
];

export function canAccessSpa(profile: UserProfile): boolean {
  return Boolean(profile.org_admin) && profile.subdomain === AppConfig.orgSubdomain;
}

export function saveRequestedPath(pathname: string = window.location.pathname): void {
  if (CALLBACK_PATHS.includes(pathname)) {
    return;
  }
  window.sessionStorage.setItem(REQUESTED_PATH_KEY, pathname);
}

export function consumeRequestedPath(): string | null {
  const requestedPath = window.sessionStorage.getItem(REQUESTED_PATH_KEY);
  window.sessionStorage.removeItem(REQUESTED_PATH_KEY);
  return requestedPath;
}

interface ResolveSignInRedirectPathArgs {
  profile: UserProfile;
  requestedPath: string | null;
  isAiSettingsEnabled: boolean;
}

export function resolveSignInRedirectPath({
  profile,
  requestedPath,
  isAiSettingsEnabled,
}: ResolveSignInRedirectPathArgs): string {
  if (!canAccessSpa(profile)) {
    return `/${AppRoutes.UNAUTHORIZED}`;
  }

  const allowedPaths = [`/${AppRoutes.ROOT_PATH}`];
  if (isAiSettingsEnabled) {
    allowedPaths.push(`/${AppRoutes.AI_SETTINGS}`);
    allowedPaths.push(ACTIVITY_LOGS_PATH);
  }

  return requestedPath && allowedPaths.includes(requestedPath) ? requestedPath : `/${AppRoutes.ROOT_PATH}`;
}
